exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".error-message{color:red;text-align:center;margin-top:30px;font-size:20px}\n", ""]);
